'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/secondsAfter.js
// module id = 208
// module chunks = 0